class CommentForm {
  constructor(container) {
    this.selectors = {
      label: 'p:not(.comment-form-cookies-consent) > label',
    };

    this.classes = {
      empty: 'is-empty',
      invalid: 'is-invalid',
    };

    this.labels = Array.from(
      container.querySelectorAll(this.selectors.label),
    ).filter(label => label.control !== null);

    this.labels.forEach(label => {
      label.parentNode.classList.toggle(
        this.classes.empty,
        label.control.value === '',
      );
      label.control.addEventListener('focus', this.onFocus);
      label.control.addEventListener('blur', this.onBlur);
      label.control.addEventListener('invalid', this.onInvalid);
    });
  }

  onFocus = ev => {
    ev.currentTarget.parentNode.classList.remove(this.classes.empty);
  };

  onBlur = ev => {
    ev.currentTarget.parentNode.classList.toggle(
      this.classes.empty,
      ev.currentTarget.value === '',
    );
    ev.currentTarget.parentNode.classList.remove(this.classes.invalid);
  };

  onInvalid = ev => {
    ev.currentTarget.parentNode.classList.add(this.classes.invalid);
  };
}

export default () => {
  Array.from(document.querySelectorAll('.c-comment-form')).forEach(
    container => new CommentForm(container),
  );
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/modules/comment-form.js